import { X, Download, FileText, ExternalLink } from "lucide-react";
import creditNoteService from "../services/creditNoteService";
import Swal from "sweetalert2";

export default function CreditNoteDetailModal({ creditNote, onClose, onDownloadPdf }) {
  // ✅ Descargar JSON
  const handleDownloadJson = async () => {
    try {
      await creditNoteService.downloadJson(creditNote.id, creditNote.numero_control);
      Swal.fire({
        icon: "success",
        title: "Descarga iniciada",
        text: "El JSON se está descargando",
        timer: 2000,
        showConfirmButton: false,
      });
    } catch (error) {
      console.error("Error descargando JSON:", error);
      Swal.fire("Error", "No se pudo descargar el JSON", "error");
    }
  };

  // ✅ Descargar JSON firmado
  const handleDownloadJsonFirmado = async () => {
    try {
      await creditNoteService.downloadJsonFirmado(creditNote.id, creditNote.numero_control);
      Swal.fire({
        icon: "success",
        title: "Descarga iniciada",
        text: "El JSON firmado se está descargando",
        timer: 2000,
        showConfirmButton: false,
      });
    } catch (error) {
      console.error("Error descargando JSON firmado:", error);
      Swal.fire("Error", error.response?.data?.error || "No se pudo descargar el JSON firmado", "error");
    }
  };

  return (
    <>
      <div className="modal fade show d-block" style={{ background: "rgba(0,0,0,0.5)" }}>
        <div className="modal-dialog modal-xl modal-dialog-centered modal-dialog-scrollable">
          <div className="modal-content card" style={{ maxHeight: "90vh" }}>
            {/* HEADER */}
            <div className="card-header">
              <h3 className="card-title" style={{ margin: 0 }}>
                📄 Detalle de Nota de Crédito
              </h3>
              <button className="btn btn-secondary btn-sm" onClick={onClose}>
                <X size={18} />
              </button>
            </div>

            {/* BODY */}
            <div className="card-body" style={{ overflowY: "auto" }}>
              {/* INFORMACIÓN GENERAL */}
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "1fr 1fr",
                  gap: "16px",
                  marginBottom: "24px",
                }}
              >
                {/* Columna Izquierda */}
                <div
                  style={{
                    padding: "16px",
                    background: "#f7fafc",
                    borderRadius: "10px",
                    border: "2px solid #e2e8f0",
                  }}
                >
                  <h4 style={{ fontSize: "16px", marginBottom: "16px", color: "#1f2937" }}>
                    Información del DTE
                  </h4>

                  <div style={{ marginBottom: "12px" }}>
                    <label style={{ fontSize: "13px", color: "#6b7280", display: "block", marginBottom: "4px" }}>
                      Número de Control
                    </label>
                    <div style={{ fontSize: "14px", fontWeight: 600, color: "#1f2937" }}>
                      {creditNote.numero_control}
                    </div>
                  </div>

                  <div style={{ marginBottom: "12px" }}>
                    <label style={{ fontSize: "13px", color: "#6b7280", display: "block", marginBottom: "4px" }}>
                      Código de Generación
                    </label>
                    <div
                      style={{
                        fontSize: "12px",
                        fontWeight: 600,
                        color: "#667eea",
                        wordBreak: "break-all",
                      }}
                    >
                      {creditNote.codigo_generacion}
                    </div>
                  </div>

                  <div style={{ marginBottom: "12px" }}>
                    <label style={{ fontSize: "13px", color: "#6b7280", display: "block", marginBottom: "4px" }}>
                      Sello de Recepción
                    </label>
                    <div
                      style={{
                        fontSize: "11px",
                        color: "#4b5563",
                        wordBreak: "break-all",
                        maxHeight: "60px",
                        overflowY: "auto",
                      }}
                    >
                      {creditNote.sello_recepcion || "Pendiente"}
                    </div>
                  </div>

                  <div style={{ marginBottom: "12px" }}>
                    <label style={{ fontSize: "13px", color: "#6b7280", display: "block", marginBottom: "4px" }}>
                      Fecha de Emisión
                    </label>
                    <div style={{ fontSize: "14px", fontWeight: 600, color: "#1f2937" }}>
                      {new Date(creditNote.fecha_emision).toLocaleDateString("es-SV", {
                        weekday: "long",
                        year: "numeric",
                        month: "long",
                        day: "numeric",
                      })}
                    </div>
                  </div>

                  <div style={{ marginBottom: "12px" }}>
                    <label style={{ fontSize: "13px", color: "#6b7280", display: "block", marginBottom: "4px" }}>
                      Tipo de Documento
                    </label>
                    <div style={{ fontSize: "14px", fontWeight: 600, color: "#1f2937" }}>
                      {creditNote.tipo_documento === "01" ? "📄 Consumidor Final" : "💼 Crédito Fiscal"}
                    </div>
                  </div>

                  <div style={{ marginBottom: "12px" }}>
                    <label style={{ fontSize: "13px", color: "#6b7280", display: "block", marginBottom: "4px" }}>
                      Estado DTE
                    </label>
                    <div>
                      {creditNote.estado_dte === "VALIDADO" && (
                        <span
                          style={{
                            padding: "6px 16px",
                            background: "#d1fae5",
                            color: "#065f46",
                            borderRadius: "8px",
                            fontSize: "13px",
                            fontWeight: 600,
                          }}
                        >
                          ✓ Validado por Hacienda
                        </span>
                      )}
                      {creditNote.estado_dte === "PENDIENTE" && (
                        <span
                          style={{
                            padding: "6px 16px",
                            background: "#fef3c7",
                            color: "#92400e",
                            borderRadius: "8px",
                            fontSize: "13px",
                            fontWeight: 600,
                          }}
                        >
                          ⏳ Pendiente
                        </span>
                      )}
                      {creditNote.estado_dte === "RECHAZADO" && (
                        <span
                          style={{
                            padding: "6px 16px",
                            background: "#fee2e2",
                            color: "#991b1b",
                            borderRadius: "8px",
                            fontSize: "13px",
                            fontWeight: 600,
                          }}
                        >
                          ✕ Rechazado
                        </span>
                      )}
                    </div>
                  </div>

                  <div>
                    <label style={{ fontSize: "13px", color: "#6b7280", display: "block", marginBottom: "4px" }}>
                      Estado
                    </label>
                    <div>
                      {creditNote.status === "active" ? (
                        <span
                          style={{
                            padding: "6px 16px",
                            background: "#dbeafe",
                            color: "#1e40af",
                            borderRadius: "8px",
                            fontSize: "13px",
                            fontWeight: 600,
                          }}
                        >
                          Activa
                        </span>
                      ) : (
                        <span
                          style={{
                            padding: "6px 16px",
                            background: "#f3f4f6",
                            color: "#6b7280",
                            borderRadius: "8px",
                            fontSize: "13px",
                            fontWeight: 600,
                          }}
                        >
                          Cancelada
                        </span>
                      )}
                    </div>
                  </div>
                </div>

                {/* Columna Derecha */}
                <div
                  style={{
                    padding: "16px",
                    background: "#f7fafc",
                    borderRadius: "10px",
                    border: "2px solid #e2e8f0",
                  }}
                >
                  <h4 style={{ fontSize: "16px", marginBottom: "16px", color: "#1f2937" }}>
                    Información del Cliente
                  </h4>

                  <div style={{ marginBottom: "12px" }}>
                    <label style={{ fontSize: "13px", color: "#6b7280", display: "block", marginBottom: "4px" }}>
                      Cliente
                    </label>
                    <div style={{ fontSize: "15px", fontWeight: 600, color: "#1f2937" }}>
                      {creditNote.sale?.client?.nombre || "N/A"}
                    </div>
                  </div>

                  {creditNote.tipo_documento === "03" && (
                    <>
                      <div style={{ marginBottom: "12px" }}>
                        <label style={{ fontSize: "13px", color: "#6b7280", display: "block", marginBottom: "4px" }}>
                          NIT
                        </label>
                        <div style={{ fontSize: "14px", fontWeight: 600, color: "#1f2937" }}>
                          {creditNote.sale?.client?.nit || "N/A"}
                        </div>
                      </div>

                      <div style={{ marginBottom: "12px" }}>
                        <label style={{ fontSize: "13px", color: "#6b7280", display: "block", marginBottom: "4px" }}>
                          NRC
                        </label>
                        <div style={{ fontSize: "14px", fontWeight: 600, color: "#1f2937" }}>
                          {creditNote.sale?.client?.nrc || "N/A"}
                        </div>
                      </div>
                    </>
                  )}

                  {creditNote.tipo_documento === "01" && (
                    <div style={{ marginBottom: "12px" }}>
                      <label style={{ fontSize: "13px", color: "#6b7280", display: "block", marginBottom: "4px" }}>
                        DUI
                      </label>
                      <div style={{ fontSize: "14px", fontWeight: 600, color: "#1f2937" }}>
                        {creditNote.sale?.client?.numero_documento || "N/A"}
                      </div>
                    </div>
                  )}

                  <div style={{ marginBottom: "12px" }}>
                    <label style={{ fontSize: "13px", color: "#6b7280", display: "block", marginBottom: "4px" }}>
                      Correo
                    </label>
                    <div style={{ fontSize: "14px", color: "#1f2937" }}>
                      {creditNote.sale?.client?.email || "N/A"}
                    </div>
                  </div>

                  <div style={{ marginBottom: "12px" }}>
                    <label style={{ fontSize: "13px", color: "#6b7280", display: "block", marginBottom: "4px" }}>
                      Teléfono
                    </label>
                    <div style={{ fontSize: "14px", color: "#1f2937" }}>
                      {creditNote.sale?.client?.telefono || "N/A"}
                    </div>
                  </div>

                  <div>
                    <label style={{ fontSize: "13px", color: "#6b7280", display: "block", marginBottom: "4px" }}>
                      Dirección
                    </label>
                    <div style={{ fontSize: "14px", color: "#1f2937" }}>
                      {creditNote.sale?.client?.direccion || "N/A"}
                    </div>
                  </div>
                </div>
              </div>

              {/* DOCUMENTO RELACIONADO */}
              <div
                style={{
                  padding: "16px",
                  background: "#fff7ed",
                  borderRadius: "10px",
                  border: "2px solid #fed7aa",
                  marginBottom: "24px",
                }}
              >
                <h4 style={{ fontSize: "16px", marginBottom: "12px", color: "#9a3412" }}>
                  📋 Documento Relacionado (Factura Original)
                </h4>
                <div style={{ fontSize: "14px", color: "#7c2d12" }}>
                  <strong>Factura:</strong> {creditNote.invoice?.numero_control || "N/A"}
                </div>
                <div style={{ fontSize: "13px", color: "#7c2d12", marginTop: "4px" }}>
                  <strong>Fecha emisión:</strong>{" "}
                  {creditNote.invoice?.fecha_emision
                    ? new Date(creditNote.invoice.fecha_emision).toLocaleDateString("es-SV")
                    : "N/A"}
                </div>
              </div>

              {/* MOTIVO */}
              <div
                style={{
                  padding: "16px",
                  background: "#fef2f2",
                  borderRadius: "10px",
                  border: "2px solid #fecaca",
                  marginBottom: "24px",
                }}
              >
                <h4 style={{ fontSize: "16px", marginBottom: "12px", color: "#991b1b" }}>
                  📝 Motivo de la Nota de Crédito
                </h4>
                <div style={{ fontSize: "14px", color: "#7f1d1d", lineHeight: "1.6" }}>
                  {creditNote.motivo_anulacion}
                </div>
              </div>

              {/* DETALLE DE PRODUCTOS */}
              {creditNote.sale?.sale_details && creditNote.sale.sale_details.length > 0 && (
                <div style={{ marginBottom: "24px" }}>
                  <h4 style={{ fontSize: "16px", marginBottom: "12px", color: "#1f2937" }}>
                    🛒 Detalle de Productos
                  </h4>
                  <div className="table-container">
                    <table className="table">
                      <thead>
                        <tr>
                          <th>Código</th>
                          <th>Descripción</th>
                          <th style={{ textAlign: "center" }}>Cantidad</th>
                          <th style={{ textAlign: "right" }}>Precio Unit.</th>
                          <th style={{ textAlign: "right" }}>Total</th>
                        </tr>
                      </thead>
                      <tbody>
                        {creditNote.sale.sale_details.map((item, index) => (
                          <tr key={index}>
                            <td>
                              <strong>{item.product?.codigo || "N/A"}</strong>
                            </td>
                            <td>{item.nombre_producto_snapshot || item.product?.nombre || "N/A"}</td>
                            <td style={{ textAlign: "center" }}>{item.cantidad}</td>
                            <td style={{ textAlign: "right" }}>
                              ${Number(item.precio_unitario_snapshot).toFixed(2)}
                            </td>
                            <td style={{ textAlign: "right", fontWeight: 600 }}>
                              ${Number(item.cantidad * item.precio_unitario_snapshot).toFixed(2)}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              )}

              {/* TOTALES */}
              <div
                style={{
                  padding: "20px",
                  background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                  borderRadius: "10px",
                  color: "#fff",
                }}
              >
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                  <div style={{ fontSize: "18px", fontWeight: 600 }}>Monto Total de la Nota</div>
                  <div style={{ fontSize: "32px", fontWeight: 700 }}>
                    ${Number(creditNote.amount).toFixed(2)}
                  </div>
                </div>
              </div>

              {/* DESCARGAS */}
              <div style={{ marginTop: "24px" }}>
                <h4 style={{ fontSize: "16px", marginBottom: "12px", color: "#1f2937" }}>
                  📥 Descargas
                </h4>
                <div style={{ display: "flex", gap: "12px", flexWrap: "wrap" }}>
                  <button
                    className="btn btn-success"
                    onClick={() => onDownloadPdf(creditNote)}
                  >
                    <Download size={16} />
                    Descargar PDF
                  </button>
                  <button className="btn btn-primary" onClick={handleDownloadJson}>
                    <FileText size={16} />
                    Descargar JSON
                  </button>
                  {creditNote.json_firmado_path && (
                    <button className="btn btn-primary" onClick={handleDownloadJsonFirmado}>
                      <FileText size={16} />
                      Descargar JSON Firmado
                    </button>
                  )}
                </div>
              </div>
            </div>

            {/* FOOTER */}
            <div
              className="card-body"
              style={{
                borderTop: "2px solid #e2e8f0",
                display: "flex",
                justifyContent: "flex-end",
                paddingTop: "var(--spacing-md)",
              }}
            >
              <button className="btn btn-secondary" onClick={onClose}>
                Cerrar
              </button>
            </div>
          </div>
        </div>
      </div>

      <div className="modal-backdrop fade show"></div>
    </>
  );
}